import {
	getCoreRowModel,
	getSortedRowModel,
	useReactTable,
	type ColumnDef,
	type TableOptions,
	type Table,
	type RowData,
} from "@tanstack/react-table";
export { createColumnHelper } from "@tanstack/react-table";

interface useOptions<TData> extends OtherOptions<TData> {
	data: TData[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Bueno yo lo he intentado
	columns: ColumnDef<TData, any>[];
}
export function useTanstackTable<TData>(
	options: useOptions<TData>,
): Table<TData> {
	const table = useReactTable<TData>({
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		// getFilteredRowModel: getFilteredRowModel(),

		defaultColumn: {
			size: -1,
		},

		...options,
	});

	return table;
}

type OtherOptions<T> = Omit<
	TableOptions<T>,
	"data" | "columns" | "getCoreRowModel"
>;

export const EMPTY_ARRAY: [] = [];

declare module "@tanstack/react-table" {
	//allows us to define custom properties for our columns
	// eslint-disable-next-line @typescript-eslint/no-unused-vars -- All declarations of 'ColumnMeta' must have identical type parameters.ts(2428)
	interface ColumnMeta<TData extends RowData, TValue> {
		filterVariant?: "text" | "range" | "select";
		filterOptions?: Array<[string, string]> | { [key: string]: string }; // Options for select filters
	}
}
